"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[966,531,639,810],{

/***/ 9797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FadeinText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hook_useShowAnimation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




function FadeinText(param) {
    let { duration =1500 , text  } = param;
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    const showAnimation = (0,hook_useShowAnimation__WEBPACK_IMPORTED_MODULE_2__/* .useShowAnimation */ .H)(ref);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("transition-opacity ", {
                "opacity-0": !showAnimation
            }, {
                "opacity-100": showAnimation
            }),
            style: {
                transitionDuration: "".concat(duration, "ms")
            },
            children: text
        })
    });
}


/***/ }),

/***/ 26:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4327);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function Image(props, ref) {
    const { alt , loading , src , ...rest } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: ref,
        srcSet: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildSrcSet */ .fY)(src),
        src: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)(src.url),
        ...rest,
        alt: alt || "",
        decoding: "async",
        loading: loading || "lazy"
    });
}));


/***/ }),

/***/ 889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronLeftIcon.js
var ChevronLeftIcon = __webpack_require__(13);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(7524);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./hook/usePagination.ts

function range(start, end) {
    let length = end - start + 1;
    return Array.from({
        length
    }, (_, idx)=>idx + start);
}
const DOTS = "...";
// https://www.freecodecamp.org/news/build-a-custom-pagination-component-in-react/
const usePagination = (param)=>{
    let { page , pageCount , siblingCount =1  } = param;
    const paginationRange = (0,react.useMemo)(()=>{
        // Pages count is determined as siblingCount + firstPage + lastPage + page + 2*DOTS
        const totalPageNumbers = siblingCount + 5;
        /*
      Case 1:
      If the number of pages is less than the page numbers we want to show in our
      paginationComponent, we return the range [1..total]
    */ if (totalPageNumbers >= pageCount) {
            return range(1, pageCount);
        }
        /*
    	Calculate left and right sibling index and make sure they are within range 1 and total
    */ const leftSiblingIndex = Math.max(page - siblingCount, 1);
        const rightSiblingIndex = Math.min(page + siblingCount, pageCount);
        /*
      We do not show dots just when there is just one page number to be inserted between the extremes of sibling and the page limits i.e 1 and total. Hence we are using leftSiblingIndex > 2 and rightSiblingIndex < total - 2
    */ const shouldShowLeftDots = leftSiblingIndex > 2;
        const shouldShowRightDots = rightSiblingIndex < pageCount - 2;
        const firstPageIndex = 1;
        const lastPageIndex = pageCount;
        /*
    	Case 2: No left dots to show, but rights dots to be shown
    */ if (!shouldShowLeftDots && shouldShowRightDots) {
            let leftItemCount = 3 + 2 * siblingCount;
            let leftRange = range(1, leftItemCount);
            return [
                ...leftRange,
                DOTS,
                pageCount
            ];
        }
        /*
    	Case 3: No right dots to show, but left dots to be shown
    */ if (shouldShowLeftDots && !shouldShowRightDots) {
            let rightItemCount = 3 + 2 * siblingCount;
            let rightRange = range(pageCount - rightItemCount + 1, pageCount);
            return [
                firstPageIndex,
                DOTS,
                ...rightRange
            ];
        }
        /*
    	Case 4: Both left and right dots to be shown
    */ if (shouldShowLeftDots && shouldShowRightDots) {
            let middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return [
                firstPageIndex,
                DOTS,
                ...middleRange,
                DOTS,
                lastPageIndex
            ];
        }
    }, [
        pageCount,
        siblingCount,
        page
    ]);
    return paginationRange;
};

;// CONCATENATED MODULE: ./hook/useWindowSize.ts
// https://github.com/uidotdev/usehooks

function useWindowSize() {
    const [size, setSize] = (0,react.useState)({
        width: null,
        height: null
    });
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return size;
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/pagination.tsx






function Pagination(param) {
    let { page , pageCount , pageSize  } = param;
    const size = useWindowSize();
    const paginationRange = usePagination({
        page,
        pageCount,
        siblingCount: size.width && size.width < 640 ? 0 : 1
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "isolate inline-flex sm:gap-2",
                "aria-label": "Pagination",
                children: [
                    page > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: "/news?page=".concat(page - 1, "&pageSize=").concat(pageSize),
                        className: "relative inline-flex justify-center items-center w-12 h-12 sm:w-10 sm:h-10 text-blue-800 hover:bg-blue-200 hover:text-blue-800 focus:z-20 focus:outline-offset-0 rounded-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeftIcon/* default */.Z, {
                                className: "h-6 w-6"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "relative inline-flex justify-center items-center w-12 h-12 sm:w-10 sm:h-10 text-gray-300 focus:z-20 focus:outline-offset-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeftIcon/* default */.Z, {
                                className: "h-6 w-6",
                                "aria-hidden": "true"
                            })
                        ]
                    }),
                    (paginationRange || []).map((item, index)=>{
                        if (item === "...") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "relative inline-flex justify-center items-center w-12 h-12 sm:w-10 sm:h-10 text-16 sm:text-19 -mt-[9px] leading-100 text-blue-800 focus:outline-offset-0",
                                children: "..."
                            }, index);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/news?page=".concat(item, "&pageSize=").concat(pageSize),
                            "aria-current": item === page ? "page" : undefined,
                            className: classnames_default()("relative z-10 inline-flex justify-center items-center w-12 h-12 sm:w-10 sm:h-10 text-16 sm:text-19 -mt-[2px] leading-100 text-blue-800 focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 rounded-full", {
                                "bg-blue-500 text-white hover:bg-blue-800": item === page
                            }, {
                                "hover:bg-blue-200 hover:text-blue-800": item !== page
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "-mt-[2px] sm:-mt-[3px]",
                                children: item
                            })
                        }, index);
                    }),
                    page < pageCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: "/news?page=".concat(page + 1, "&pageSize=").concat(pageSize),
                        className: "relative inline-flex justify-center items-center w-12 h-12 sm:w-10 sm:h-10 text-blue-800 hover:bg-blue-200 hover:text-blue-800 focus:z-20 focus:outline-offset-0 rounded-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Next"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                className: "h-6 w-6"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "relative inline-flex justify-center items-center w-12 h-12 sm:w-10 sm:h-10 text-gray-300 focus:z-20 focus:outline-offset-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Next"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                className: "h-6 w-6",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 3810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PageTitleSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2606);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(608);



function PageTitleSection(param) {
    let { data: { title  }  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_2__/* .ContainerSize.wide */ .B.wide,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "grid grid-cols-12 gap-1.5 md:gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-32 md:text-35 leading-130 font-bold text-blue-800 col-start-2 col-span-11 lg:col-start-4 lg:col-span-6",
                children: title
            })
        })
    });
}


/***/ }),

/***/ 2639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RichTextSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2606);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(608);



function RichTextSection(param) {
    let { data: { title , html  }  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_2__/* .ContainerSize.wide */ .B.wide,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "grid grid-cols-12 gap-1.5 md:gap-6",
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-32 md:text-35 leading-130 font-bold text-blue-800 col-start-2 col-span-11 lg:col-start-4 lg:col-span-6",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-start-2 col-span-10 lg:col-start-4 lg:col-span-6 prose",
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            ]
        })
    });
}


/***/ }),

/***/ 4531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TeaserTextSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(6684);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/container.tsx
var container = __webpack_require__(2606);
// EXTERNAL MODULE: ./lib/types/index.ts
var types = __webpack_require__(608);
// EXTERNAL MODULE: ./components/animation/fadein-text.tsx
var fadein_text = __webpack_require__(9797);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/image.tsx
var components_image = __webpack_require__(26);
// EXTERNAL MODULE: ./hook/useShowAnimation.ts
var useShowAnimation = __webpack_require__(1269);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/animation/scrolling-image.tsx





function ScrollingImage(props) {
    const { className , ...rest } = props;
    const ref = (0,react.useRef)(null);
    const showAnimation = (0,useShowAnimation/* useShowAnimation */.H)(ref);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, {
        ref: ref,
        className: classnames_default()(className, "transition duration-[1500ms]", {
            "scale-105": !showAnimation,
            "scale-100": showAnimation
        }),
        ...rest
    });
}

// EXTERNAL MODULE: ./components/vimeo.tsx + 1 modules
var vimeo = __webpack_require__(9972);
;// CONCATENATED MODULE: ./components/sections/teaser-text.tsx









function TeaserTextSection(param) {
    let { data: { image , vimeoUrl , videoPreset , videoStartAtSecond , title , subTitle , link , layout , paragraph  } , fixedHeight =false  } = param;
    const landscape = !image || image.width > image.height;
    const teaserStyles = classnames_default()("rounded-xl md:rounded-3xl col-span-12 overflow-hidden", {
        "md:order-1": layout === "ImageLeft",
        "md:order-2": layout === "ImageRight",
        "md:col-start-1 lg:col-start-2": landscape && layout === "ImageLeft",
        "md:col-start-2 lg:col-start-3": !landscape && layout === "ImageLeft",
        "md:col-span-6 lg:col-span-5": landscape,
        "md:col-span-5 lg:col-span-4": !landscape,
        "h-96 object-cover": fixedHeight
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        size: types/* ContainerSize.wide */.B.wide,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-12 gap-1.5 md:gap-6 items-center",
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollingImage, {
                    className: teaserStyles,
                    src: image,
                    height: image.height,
                    width: image.width,
                    alt: image.alternativeText,
                    sizes: "(max-width: 768px) 100vw,50vw"
                }),
                vimeoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: teaserStyles,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vimeo/* default */.Z, {
                        url: vimeoUrl,
                        preset: videoPreset,
                        start: videoStartAtSecond
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("mt-4 md:mt-0 col-start-2 col-span-10 md:col-span-4", {
                        "md:col-start-3 order-1": layout === "ImageRight",
                        "md:order-2": layout === "ImageLeft"
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-iceblue-500 font-bold mb-4 text-17 leading-140 md:text-20 md:leading-124",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fadein_text/* default */.Z, {
                                text: subTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-blue-800 text-22 leading-130 md:text-35 md:leading-130 font-bold",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fadein_text/* default */.Z, {
                                text: title
                            })
                        }),
                        paragraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "prose image-text mt-8",
                            dangerouslySetInnerHTML: {
                                __html: paragraph
                            }
                        }),
                        link && /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            className: classnames_default()("uppercase font-bold text-13 leading-140 tracking-5 text-blue-800 inline-flex items-center mt-8 group"),
                            href: link.url,
                            children: [
                                link.text,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowIcon */.e0, {
                                    className: "w-12 ml-4 transition-transform duration-500 group-hover:translate-x-2"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 4169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4327);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function Seo(param) {
    let { title , seo , url  } = param;
    var _facebookData_image, _twitterData_image;
    const { metaDescription , metaTitle , metaImageUrl , metaRobots , structuredData , canonicalURL , keywords , metaSocial  } = seo !== null && seo !== void 0 ? seo : {
        metaTitle: title,
        metaDescription: title,
        metaImageUrl: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)("/logo.svg"),
        metaSocial: []
    };
    const facebookData = metaSocial.find((meta)=>meta.socialNetwork == "Facebook");
    const twitterData = metaSocial.find((meta)=>meta.socialNetwork == "Twitter");
    var _facebookData_title, _facebookData_description, _facebookData_image_url, _twitterData_title, _twitterData_description, _twitterData_image_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: (_facebookData_title = facebookData === null || facebookData === void 0 ? void 0 : facebookData.title) !== null && _facebookData_title !== void 0 ? _facebookData_title : metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: (_facebookData_description = facebookData === null || facebookData === void 0 ? void 0 : facebookData.description) !== null && _facebookData_description !== void 0 ? _facebookData_description : metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)((_facebookData_image_url = facebookData === null || facebookData === void 0 ? void 0 : (_facebookData_image = facebookData.image) === null || _facebookData_image === void 0 ? void 0 : _facebookData_image.url) !== null && _facebookData_image_url !== void 0 ? _facebookData_image_url : metaImageUrl)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: (_twitterData_title = twitterData === null || twitterData === void 0 ? void 0 : twitterData.title) !== null && _twitterData_title !== void 0 ? _twitterData_title : metaTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: (_twitterData_description = twitterData === null || twitterData === void 0 ? void 0 : twitterData.description) !== null && _twitterData_description !== void 0 ? _twitterData_description : metaDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: (0,_lib_image__WEBPACK_IMPORTED_MODULE_1__/* .buildImageUrl */ .Sc)((_twitterData_image_url = twitterData === null || twitterData === void 0 ? void 0 : (_twitterData_image = twitterData.image) === null || _twitterData_image === void 0 ? void 0 : _twitterData_image.url) !== null && _twitterData_image_url !== void 0 ? _twitterData_image_url : metaImageUrl)
            }),
            metaRobots && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: metaRobots
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "googlebot",
                        content: metaRobots
                    })
                ]
            }),
            structuredData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: structuredData
                    }
                }, "structured-data")
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            canonicalURL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalURL
            })
        ]
    });
}


/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useShowAnimation; }
/* harmony export */ });
/* harmony import */ var _useOnScreen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4013);

function useShowAnimation(ref) {
    const [, enterCount] = (0,_useOnScreen__WEBPACK_IMPORTED_MODULE_0__/* .useOnScreen */ .R)(ref);
    const showAnimation = enterCount >= 1;
    return showAnimation;
}


/***/ }),

/***/ 9960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ parseDate; }
/* harmony export */ });
const options = {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "Europe/Zurich"
};
/**
 * Will format dates and render a string like "January 1, 2020"
 * Note: that the time is set to 1am in switzerland. This is not correct for news.
 * News should be saved with a time because a news article published on Jan 1 at 10am
 * is published on the the 31st of December from a US perspective.
 */ function parseDate(date) {
    return new Intl.DateTimeFormat("en-US", options).format(new Date(date).setUTCHours(1, 0, 0, 0));
}


/***/ }),

/***/ 13:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronLeftIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 7524:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronRightIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);